import React from 'react'
import Btn from './Button.module.css'


const Button=(props)=>{
    return(
        <button  className={Btn[props.ClassBtn]} onClick={props.ClickHandler} disabled={props.disabledProps}>{props.Value}</button>
    )  

}
export default Button;